export default "__VITE_ASSET__f4372b6e__"